import { ConfirmActionButton } from "./ConfirmActionButton";

// TODO: Use this instead of buttons in other pages
interface SaveButtonProps {
  /** Async save handler; should return true on success */
  handleSave: () => Promise<boolean>;
  /** Optional button label, defaults to "Save" */
  buttonLabel?: string;
  /** Confirmation message, defaults to generic */
  confirmMessage?: string;
  /** If false, skips confirmation modal and saves immediately */
  requireConfirmation?: boolean;
  styleClasses?: string
  disabled?: boolean
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  handleSave,
  buttonLabel = 'Save',
  confirmMessage = 'Are you sure you want to save this item? This action cannot be undone.',
  requireConfirmation = true,
  styleClasses,
  disabled = false
}) => (
  <ConfirmActionButton
    onAction={handleSave}
    variant="success"
    actionLabel="Save"
    mnemonic="s"
    confirmTitle="Confirm Save"
    confirmMessage={confirmMessage}
    buttonLabel={buttonLabel}
    requireConfirmation={requireConfirmation}
    disabled={disabled}
    className={styleClasses}
  />
);

export default SaveButton;
